<template>
  <section>
    <HeroSection headName="Cadastro de Envio" :searchBar="false" :addButton="false">
    </HeroSection>

    <div class="container">

      <form class="form">
        <div class="form__box" v-if="loading">
          <h2 class="form__name">
            <DataLoading rows="1" height="50px" />
          </h2>

          <div class="form__content">
            <DataLoading rows="4" height="80px" />
          </div>
        </div>

        <div class="form__wrap" v-if="!loading">
          <div class="form__box" v-if="isUserAdmin()">
            <h2 class="form__name">
              Utilizador
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormSearch label="Pesquisar Utilizador" v-model:modelValue="searcher" v-model:modelItem="sender" :dataList="senderListData" />
              </div>

              <div class="form__row">
                <FormInput label="Nome de Utilizador" :required="true" v-model:modelValue="model.senderName" width="50%"/>

                <FormInput label="E-mail do Utilizador" :required="true" v-model:modelValue="model.senderReplyToEmail" width="50%"/>
              </div>
            </div>
          </div>

          <div class="form__box">
            <h2 class="form__name">
              Lista
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormSearch2 label="Pesquisar Lista" v-model:modelValue="searcher2" v-model:modelItem="list" :dataList="listListData" />
              </div>

              <div class="form__row">
                <FormInput label="Nome da Lista" :required="true" v-model:modelValue="model.listName"/>
              </div>
            </div>
          </div>

          <div class="form__box">
            <h2 class="form__name">
              Conteúdo
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormInput label="Assunto da Mensagem" :required="true" v-model:modelValue="model.subjectContent"/>
              </div>

              <div class="form__row">
                <FormEditor label="Corpo da Mensagem" :required="true" v-model:modelValue="model.messageContent" height="500px"/>
                <div class="form__obs">tags disponiveis: [referencia] e [email]</div>
              </div>
            </div>
          </div>

          <FormBottom :data="button" @submit="submit()" v-if="model.shipStatus == 'Draft'"/>

        </div>
      </form>
    </div>
  </section>
</template>

<script>

import HeroSection from '@components/_partials/HeroSection.vue';
import DataLoading from '@components/_partials/DataLoading.vue';
import FormInput from '@components/_form/FormInput.vue';
import FormSearch from '@components/_form/FormSearch.vue';
import FormSearch2 from '@components/_form/FormSearch2.vue';
import FormEditor from '@components/_form/FormEditor.vue';
import FormBottom from '@components/_form/FormBottom.vue';
import { baseUrl, padVal, brDate, docMask, phoneMask, brMoney, globalDate } from '@helpers/functions';
import { typeServices, schedulePeriod, isActive } from '@helpers/constants'
import envio from '@services/envio';
import usuario from '@services/usuario';
import lista from '@services/lista';
import storage from '@/config/storage';

export default {
  components: {
    HeroSection,
    DataLoading,
    FormInput,
    FormSearch,
    FormSearch2,
    FormBottom,
    FormEditor
  },
  data() {
    return {
      loading: false,
      button: { spinner: false, label: 'Salvar Envio', color: 'primary' },
      model: { sender: {}, list: {}, shipStatus: 'Draft' },
      senderListData: [],
      listListData: [],
      sender: {},
      list: {},
      dataList: [],
      pagination: {},
      searcher: '',
      searcher2: '',
      search: '',
      search2: '',
      isCpf: true,
      helpers: {
        cpf: '',
        cnpj: ''
      }
    }
  },
  methods: {
    baseUrl,
    brDate,
    padVal,
    docMask,
    phoneMask,
    brMoney,
    globalDate,
    typeServices,
    schedulePeriod,
    isActive,
    loadForm: function(_id) {
      const _this = this;
      _this.loading = true;

      envio.show(_id).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          _this.model = res.data;
          _this.sender = res.data.sender;
          _this.loading = false;
        }
      });
    },
    submit() {
      const _this = this;
      const _id = _this.hasIdx();
      const button = _this.button;

      let data = _this.model;



      _this.button = {
        spinner: true,
        label: 'Salvando...',
        color: 'warning'
      }
      envio.save(_id, data).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          _this.button = {
            spinner: false,
            label: 'Salvo com sucesso!',
            color: 'success'
          }

          setTimeout(() => this.$router.push('/envios'), 1000);
        }

        if(typeof res === 'undefined' || !res.success) {
          _this.button = {
            spinner: false,
            label: 'Houve um erro ao processar.',
            color: 'danger'
          }
          setTimeout(() => _this.button = button, 3000);
        }
      })

    },
    hasIdx() {
      const _this = this;
      return _this.$route.params.id ? _this.$route.params.id : null;
    },
    isUserAdmin() {
      const local = 'mail4fly--user';
      const user = storage.get(local);
      return user && user.role === 'admin' ? true : false;
    },
  },
  watch: {
    '$route.params.page'(paged) {
     this.initLoad(paged);
    },
    'searcher'(search) {
      const _this = this;
      if(search && search.length > 3) {
        usuario.retrieve({ search }).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          const { docs } = res.data;
          _this.senderListData = docs;
        }
      });
      }

      if(!search || search.length == 0) {
        _this.senderListData = [];
      }
    },
    'searcher2'(search) {
      const _this = this;
      if(search && search.length > 3) {
        lista.retrieve({ search }).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          const { docs } = res.data;
          _this.listListData = docs;
        }
      });
      }

      if(!search || search.length == 0) {
        _this.listListData = [];
      }
    },
    'sender'(sender) {
      const _this = this;
      const { _id, senderName, senderReplyToEmail } = sender;

      _this.model.senderId = _id;
      _this.model.senderName = senderName;
      _this.model.senderReplyToEmail = senderReplyToEmail;
      _this.senderListData = [];
      _this.searcher = '';
    },
    'list'(list) {
      const _this = this;
      const { _id, listName } = list;

      _this.model.listId = _id;
      _this.model.listName = listName;
      _this.senderListData = [];
      _this.searcher2 = '';
    }
  },
  mounted(){
    const _id = this.hasIdx();
    if(_id) this.loadForm(_id);
  }
};

</script>
